import { ref, watch, computed, onMounted, reactive } from 'vue'

export default function useManageReservaExpressa(context) {

    /*
    * ref => em arrays, strings, numeros (retorna variavel com value e effect)
    * reactive => objetos (nao retorna variavel com value)
    */

    const tickets = ref({})
    const selected_special_booking_type = ref({})

    function calculateTotalCost(){
        if(tickets.value != undefined){
            return Object.values(tickets.value).map(function(val, idx){
                var quantity = Number(val.quantity)
                var price = val.price != undefined ? typeof val.price === "number" ? val.price : parseFloat(val.price.replace(/[^0-9.]/g, ".")) : 0.0
                var final_value = 0.0

                if(selected_special_booking_type.price != undefined && selected_special_booking_type.price.length > 0){
                    price = Number(selected_special_booking_type.price).toFixed(2)
                }

                if(quantity > 0){
                    final_value = (price * quantity)
                }

                return final_value
            }).filter(i => i != undefined).reduce((prev, cur) => { return prev + cur }, 0.0)
        }
        return 0.0
    }

    // GETTERS & SETTERS
    function setTickets(value){ tickets.value = value }
    function getTickets(){ return tickets.value }

    function setSelectedSpecialBookingType(value){ selected_special_booking_type.value = value }
    function getSelectedSpecialBookingType(){ return selected_special_booking_type.value }

    return {
        // FUNCTION
        calculateTotalCost,

        // GETTERS & SETTERS
        setTickets,
        getTickets,
        setSelectedSpecialBookingType,
        getSelectedSpecialBookingType,
    }

}
